import { gql } from '@apollo/client';

export const EDIT_DAILYCHIRP_MUTATION = gql`
  mutation EditDailychirp($data: updateDailychirpInput!) {
    updateDailychirp(input: $data) {
      dailychirp {
        id
        date
        dailybirdData
        pdfDocuments
      }
    }
  }
`;
